import { render, staticRenderFns } from "./CampusEdit.vue?vue&type=template&id=740774cd&scoped=true"
import script from "./CampusEdit.vue?vue&type=script&lang=js"
export * from "./CampusEdit.vue?vue&type=script&lang=js"
import style0 from "./CampusEdit.vue?vue&type=style&index=0&id=740774cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740774cd",
  null
  
)

export default component.exports